// Scripts
import '~scripts/main';

// Styles
import 'styles/pages/charity.scss';

// Packages
import eases from 'eases';
import anime from 'animejs/lib/anime.es.js';

// Blocks
import Navigation from '~scripts/blocks/navigation';
import initRequestForm from '~scripts/blocks/request-form';

// Components
import '~scripts/components/modals';

// Core
import { BREAKPOINTS } from '~scripts/core/breakpoints';
import { scrollAnimationProgress } from '~scripts/core/animations';
import { isInViewport } from '~scripts/core/helpers';
import { VKVideoPlayer } from '~scripts/core/VKVideoPlayer';

// // Swiper
import Swiper from 'swiper';
import { EffectFade, Navigation as SwiperNavigation, Pagination as SwiperPagination } from 'swiper/modules';
Swiper.use([EffectFade, SwiperNavigation, SwiperPagination]);

// Media
const mediaSm = window.matchMedia(`(max-width: ${BREAKPOINTS.smMax})`);

//
// HEADER
//
const header = document.getElementById('header');

const toggleHeader = () => {
  if (window.scrollY - 200 > window.innerHeight) {
    header.classList.add('header--show');
  } else {
    header.classList.remove('header--show');
  }
};

window.addEventListener('scroll', toggleHeader);
toggleHeader();

//
// NAVIGATION
//
Navigation();

//
// SLIDESHOW
//
const slideshow = () => {
  const timeout = 4000;
  const slides = document.querySelectorAll('.js-banner__picture');
  const slidesLength = slides.length;
  let currentIndex = 0;

  slides[currentIndex].classList.remove('banner__picture--hidden');

  setTimeout(() => {
    slides[currentIndex].classList.add('banner__picture--current');
  }, 20);

  const changeImage = () => {
    let prevIndex = currentIndex;

    setTimeout(() => {
      slides[prevIndex].classList.add('banner__picture--hidden');
      slides[prevIndex].classList.remove('banner__picture--current');
    }, timeout / 4);

    currentIndex = (currentIndex + 1) % slidesLength;
    slides[currentIndex].classList.remove('banner__picture--hidden');

    setTimeout(() => {
      slides[currentIndex].classList.add('banner__picture--current');
    }, 20);

    if (slidesLength - 1 === currentIndex) {
      let index = currentIndex;

      setTimeout(() => {
        slides[index].classList.add('banner__picture--fadeDown');
      }, timeout);
    }

    if (currentIndex === 1) {
      slides[slidesLength - 1].classList.remove('banner__picture--fadeDown');
    }

    setTimeout(changeImage, timeout);
  };

  setTimeout(changeImage, timeout);
};

slideshow();

//
// VIDEO
//
const handlePlayButtonClick = (button, playerList, id) => {
  button.classList.add('video__thumb--hidden');
  try {
    playerList[`player-${id}`].play();
  } catch (error) {
    console.warn('Video player is not ready');
  }
};

const handleWindowScroll = (button, playerList, id) => {
  if (!isInViewport(button)) {
    if (button.classList.contains('video__thumb--hidden')) {
      button.classList.remove('video__thumb--hidden');
      playerList[`player-${id}`].pause();
    }
  }
};

const playerOptions = {
  videoElements: '.js-video',
  playButtonSelector: '.js-play-video',
  handlePlayButtonClick: handlePlayButtonClick,
  handleWindowScroll: handleWindowScroll,
};

const player = await new VKVideoPlayer(playerOptions);
player.init();

//
// SLIDERS
//
//
// PERSON
const personSlider = document.querySelectorAll('.js-person-slider');

personSlider.forEach((slider) => {
  const nextBtn = slider.querySelector('.swiper-button-next');
  const prevBtn = slider.querySelector('.swiper-button-prev');
  const pagination = slider.querySelector('.swiper-pagination');

  new Swiper(slider, {
    simulateTouch: false,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    loop: true,
    navigation: {
      nextEl: nextBtn,
      prevEl: prevBtn,
    },
    pagination: {
      el: pagination,
      clickable: true,
    },
    slidesPerView: 1,
    spaceBetween: 0,
  });
});

// HELP ITEM
const helpItemSlider = document.querySelectorAll('.js-help-item-slider');

helpItemSlider.forEach((slider) => {
  const nextBtn = slider.querySelector('.swiper-button-next');
  const prevBtn = slider.querySelector('.swiper-button-prev');

  new Swiper(slider, {
    simulateTouch: false,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    loop: true,
    navigation: {
      nextEl: nextBtn,
      prevEl: prevBtn,
    },
    slidesPerView: 1,
    spaceBetween: 0,
  });
});

//
// BANNER ANIMATION
//
const handleBannerAnimation = () => {
  const banner = document.querySelector('.js-banner');
  const headerLogo = header.querySelector('.logo');

  const bannerAnimation = anime({
    targets: '.banner',
    translateY: window.innerHeight * -1,
    easing: 'linear',
    autoplay: false,
    round: 5,
  });

  scrollAnimationProgress(banner, {
    getStart: () => 0,
    getEnd: () => window.innerHeight - window.innerHeight / 2.5,
    lerpValue: 1,
    onProgress: (progress) => {
      banner.classList.toggle('banner--out-of-view', progress === 1);

      header.classList.toggle('header--hidden', progress > 0.02);
      header.classList.toggle('header--light', progress < 1);
      headerLogo.classList.toggle('logo--inverted', progress < 1);

      if (!mediaSm.matches) {
        bannerAnimation.seek(progress * bannerAnimation.duration);
      } else {
        banner.style.transform = 'translateY(0px)';
      }
    },
  });
};

handleBannerAnimation();
mediaSm.addEventListener('change', handleBannerAnimation);

//
// ABOUT ANIMATION
//
let stopAboutScrollAnimation = null;

const handleBannerPhotoAnimation = () => {
  const aboutAnimation = document.querySelector('.js-about');

  if (mediaSm.matches) {
    if (stopAboutScrollAnimation && typeof stopAboutScrollAnimation === 'function') {
      stopAboutScrollAnimation();
    }
  } else {
    stopAboutScrollAnimation = scrollAnimationProgress(aboutAnimation, {
      getStart() {
        return window.innerHeight / 8;
      },
      getEnd(el, start) {
        return start + window.innerHeight / 4;
      },
    });
  }
};

handleBannerPhotoAnimation();
mediaSm.addEventListener('change', handleBannerPhotoAnimation);

const personItems = document.querySelectorAll('.js-person');

personItems.forEach((item) => {
  scrollAnimationProgress(
    item,
    {
      getStart(el) {
        const rect = el.getBoundingClientRect();
        return rect.top + window.scrollY - (window.innerHeight + 50);
      },
      getEnd(el, start) {
        return start + 200;
      },
    },
    eases.linear
  );
});

// Parallax
let stopSectionPhotoParallaxAnimation = [];

const handleSectionPhotoParallaxAnimation = () => {
  const sectionPhotosPictures = document.querySelectorAll('.js-play-video > picture');

  if (mediaSm.matches) {
    stopSectionPhotoParallaxAnimation.forEach((stop) => stop());
  } else {
    stopSectionPhotoParallaxAnimation = Array.from(sectionPhotosPictures, (sectionPhotoPicture) => {
      return scrollAnimationProgress(sectionPhotoPicture, {
        getStart(el) {
          const rect = el.getBoundingClientRect();
          return rect.top + window.scrollY - window.innerHeight;
        },
        getEnd(el, start) {
          const height = el.offsetHeight;
          return start + window.innerHeight + height;
        },
      });
    });
  }
};

handleSectionPhotoParallaxAnimation();
mediaSm.addEventListener('change', handleSectionPhotoParallaxAnimation);

//
// DEMO REQUEST FORM
//
const demoRequestForms = document.querySelectorAll('.js-demo-request-form');

demoRequestForms.forEach((form) => {
  initRequestForm(form);
});
